import { ResultService } from './service/ResultService'

export const resultService = new ResultService()
